import { AccordionItem, Text, List, Stack } from 'braid-design-system';
export const Indemnity = () => (
  <AccordionItem id="indemnity" label="Indemnity">
    <List type="number" start={45}>
      <Stack space="medium">
        <Text>
          You indemnify and will keep indemnified the SEEK Group, its officers,
          employees and agents against all claims, actions, suits, liabilities,
          actual or contingent costs, damages and expenses incurred by us as a
          direct result of:
        </Text>
        <List type="alpha">
          <Text>any negligent act or omission by you; or</Text>
          <Text>
            an actual or alleged breach by you of any law, legislation,
            regulations, by-laws, ordinances or codes of conduct which occurs as
            a result of your use of the SEEK API.
          </Text>
        </List>
        <Text>
          Each party&apos;s liability under these terms will be reduced to the
          extent that the relevant loss or damage was caused or contributed to
          by the other party.
        </Text>
      </Stack>
    </List>
  </AccordionItem>
);
